<template>
  <div>
    <h3 class="info-title">认证设置</h3>
    <el-divider />
    <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="100px" size="small">
      <el-form-item prop="accountName" label="TP-LINK ID"> {{ accountName }} </el-form-item>
      <el-form-item prop="personName" label="真实姓名">
        <el-input v-model="form.personName" clearable placeholder="请输入真实姓名" />
      </el-form-item>
      <el-form-item prop="phone" label="手机号码">
        <el-input v-model="form.phone" clearable placeholder="请输入手机号码" />
      </el-form-item>
      <el-form-item prop="veriCode" label="验证码">
        <el-input v-model="form.veriCode" clearable placeholder="请输入验证码" style="width: 70%; margin-right: 1%"/>
        <el-button size="small" style="width: 29%" @click="getPhoneVerifyCode" type="primary" :disabled="canClick"> {{ content }} </el-button>
      </el-form-item>
    </el-form>
    <div class="protocol">
<!--      <el-checkbox v-model="checked" />&nbsp;我已阅读并接受<el-button type="text" @click="checkProtocol.agreement=true">《用户服务协议》</el-button><el-button type="text" @click="checkProtocol.privacy=true">《隐私政策》</el-button><el-button type="text" @click="checkProtocol.service=true">《TPDDNS 服务协议》</el-button>-->
      <el-checkbox v-model="checked" />&nbsp;
      我已阅读并接受
      《<a href="https://src.tplinkcloud.com.cn/realnameagreement.html" target="_blank">用户协议</a>》
      《<a href="https://src.tplinkcloud.com.cn/pipagreement.html" target="_blank">隐私政策</a>》
      《<a href="https://src.tplinkcloud.com.cn/ddnsagreement.html" target="_blank">TPDDNS 服务协议</a>》
    </div>
    <agreement :dialog-visible="checkProtocol.agreement" @close="checkProtocol.agreement=false" @refuse="handleRefuse" @agree="handleAgree"/>
    <privacy :dialog-visible="checkProtocol.privacy" @close="checkProtocol.privacy=false" @refuse="handleRefuse" @agree="handleAgree"/>
    <service :dialog-visible="checkProtocol.service" @close="checkProtocol.service=false" @refuse="handleRefuse" @agree="handleAgree"/>
    <div class="butt">
      <el-button :loading="loading" type="primary" :disabled="!checked" @click="handleSubmit">
        <span v-if="!loading"> 同意协议并提交 </span>
        <span v-else> 提 交 中... </span>
      </el-button>
    </div>
  </div>
</template>

<script>
import Config from "@/config"
import Agreement from "../../components/agreement.vue"
import Privacy from "../../components/privacy.vue"
import Service from "../../components/service.vue"
import {getAccountType, getAppType, getUUID, notify, validateContact} from "@/utils/util"
import {left} from "core-js/internals/array-reduce";
import Cookies from "js-cookie";
import {removeToken} from "@/utils/auth";
import {getPhoneVerifyCode} from "@/api/certify"

export default {
  name: "Person",
  components: { Agreement, Privacy, Service },
  props: {
    accountName: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      form: {
        accountName: "",
        personName: "",
        phone: "",
        veriCode: ""
      },
      rules: {
        accountName: [{required: true, message: "请输入TP-LINK ID", trigger: "blur"}],
        personName: [{max: 25, message: '名字最长25个字', trigger: 'blur'}],
        phone: [{required: true, message: "请输入手机号", trigger: "blur"}, {validator: validateContact, trigger: "blur"}],
        veriCode: [{required: true, message: "请输入验证码", trigger: "blur"}, {min: 6, max: 6, message: '验证码为6位', trigger: 'blur'}],
      },
      checked: false,
      loading: false,
      checkProtocol: { agreement: false, privacy: false, service: false },
      content: "发送验证码",
      totalTime: 60,
      canClick: false
    }
  },
  watch: {
    accountName: function () {
      console.log('accountName', this.accountName)
      this.form.accountName = this.accountName
    }
  },
  methods: {
    left,
    logout () {
      Cookies.remove("accountName")
      Cookies.remove("accountPassword")
      Cookies.remove("rememberMe")
      removeToken()
      console.log('Back to login page!')
      this.$router.replace("/login")
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    getPhoneVerifyCode () {
      if (this.canClick) return
      if (!this.form.phone) {
        notify(Config.notifyWarn, "请先输入手机号!")
      } else {
        const params = {
          accountName: this.form.accountName,
          phone: this.form.phone,
        }
        getPhoneVerifyCode(params).then(response => {
          if (response.error_code === 0) {
            notify(Config.notifySuc, "验证码发送成功！")
            this.canClick = true
            const clock = window.setInterval(() => {
              this.totalTime--
              this.content = this.totalTime + 's后重发'
              if (this.totalTime < 0) {
                window.clearInterval(clock)
                this.content = '重发验证码'
                this.totalTime = 60
                this.canClick = false
              }
            }, 1000)
          } else {
            notify(Config.notifyErr, Config.errorMsg[response.error_code])
            if (response.error_code === Config.tokenTimeout) {
              this.logout()
            }
          }
        }).catch(error => {
          console.log(error)
          notify(Config.notifyErr, Config.serverErrorMsg)
        })
      }
    },
    handleSubmit () {
      this.loading = true
      this.form.accountName = this.accountName
      this.$refs.form.validate(valid => {
        if (valid) {
          const submitData = {
            accountName: this.form.accountName,
            personName: this.form.personName,
            phone: this.form.phone,
            veriCode: this.form.veriCode
          }
          this.$emit('onSubmit', submitData, response => {
            this.loading = false
            if (response) {
              this.resetForm()
            } else {
              console.log("Submit error!")
            }
          })
        } else {
          this.loading = false
          notify(Config.notifyErr, Config.submitErr)
        }
      })
    },

    handleAgree ({key}) {
      console.log(key)
      this.checkProtocol[key] = false
      this.checked = true
    },
    handleRefuse ({key}) {
      this.checkProtocol[key] = false
      this.checked = false
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}

.info-title {
  margin-top: 5%;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 20px;
  color: blue;
  width: 300px;
  height: 160px;
  line-height: 160px;
  text-align: center;
}

.avatar {
  width: 300px;
  height: 160px;
  display: block;
}

.butt {
  margin-top: 20px;
}

.el-row {
  margin: 1% 0;
}

p:before {
  content: "*";
  color: red;
  font-size: 14px;
}

p {
  font-size: 14px;
}

.protocol {
  font-size: 14px;
}

a {
  color: #409EFF;
}
</style>